import { axiosInstance } from '../config/axiosConfig';
import { API_ENDPOINTS } from '../endpoints/endpoints';

/**
 * DRAFT / CLOSED / COMPLETED all keep the card hidden in the app — only
 * ACTIVE (and inside its date window) is shown to users.
 */
export type GiveawayStatus = 'DRAFT' | 'ACTIVE' | 'CLOSED' | 'COMPLETED';

export type GiveawayEntryStatus =
  | 'PENDING'
  | 'SUBMITTED'
  | 'VERIFIED'
  | 'REJECTED';

export interface Giveaway {
  id: string;
  title: string;
  description?: string | null;
  prize?: string | null;
  instagramPostUrl?: string | null;
  instagramHandle?: string | null;
  requiredTagCount: number;
  rewardCredits: number;
  status: GiveawayStatus;
  startsAt?: string | null;
  endsAt?: string | null;
  createdAt: string;
  updatedAt: string;
  entryCount?: number;
}

export interface CreateGiveawayRequest {
  title: string;
  description?: string;
  prize?: string;
  instagramPostUrl?: string;
  instagramHandle?: string;
  requiredTagCount?: number;
  rewardCredits?: number;
  status?: GiveawayStatus;
  startsAt?: string | null;
  endsAt?: string | null;
}

export type UpdateGiveawayRequest = Partial<CreateGiveawayRequest>;

export interface GiveawayStats {
  total: number;
  winners: number;
  PENDING: number;
  SUBMITTED: number;
  VERIFIED: number;
  REJECTED: number;
}

export const giveawayService = {
  async getGiveaways(): Promise<Giveaway[]> {
    const res = await axiosInstance.get(API_ENDPOINTS.GIVEAWAY.GIVEAWAYS);
    return res.data;
  },

  async createGiveaway(data: CreateGiveawayRequest): Promise<Giveaway> {
    const res = await axiosInstance.post(
      API_ENDPOINTS.GIVEAWAY.GIVEAWAYS,
      data,
    );
    return res.data;
  },

  async updateGiveaway(
    id: string,
    data: UpdateGiveawayRequest,
  ): Promise<Giveaway> {
    const res = await axiosInstance.patch(
      API_ENDPOINTS.GIVEAWAY.GIVEAWAY_BY_ID(id),
      data,
    );
    return res.data;
  },

  async deleteGiveaway(id: string): Promise<void> {
    await axiosInstance.delete(API_ENDPOINTS.GIVEAWAY.GIVEAWAY_BY_ID(id));
  },

  async getStats(id: string): Promise<GiveawayStats> {
    const res = await axiosInstance.get(API_ENDPOINTS.GIVEAWAY.STATS(id));
    return res.data;
  },
};
